module.exports = __webpack_public_path__ + "static/media/bass.e50cc98c.m4a";